/* BOSSVI · Vídeos (metaobjeto «Vídeo BOSSVI»). 15 oct 2026.
   Tarjetas [data-bvv] en la galería de la ficha y en la sección «Vídeos BOSSVI» (ficha, home, colecciones).
   - Carga el vídeo solo cuando la tarjeta está cerca de verse. 16 oct: calidad máxima en todos los aparatos:
     siempre el MP4 de 1080p (sin streaming HLS, que arrancaba borroso en clips cortos en iPhone y en Chrome);
     si la tarjeta trae data-src-max (versión propia en alta calidad), esa.
   - Un toque: arranca con sonido; otro toque: pausa. Barra fina para saltar y botón de sonido.
   - Se pausa al salir de pantalla y cuando arranca otro vídeo.
   - Con ratón, el pulsado sobre la tarjeta no arrastra el carrusel de la galería ni abre el zoom.
   - Tarjetas con data-bucle (sección «Vídeos BOSSVI»): al estar a la vista arrancan en silencio y en bucle, como un reel;
     un toque las reinicia con sonido. Con «reducir movimiento» no se mueven hasta que se tocan.
   - Medición: Shopify.analytics.publish('bv_video_bucle' (visto en silencio) | 'bv_video_play' (con sonido) | 'bv_video_fin',
     {video, productos, contexto, pagina, producto_pagina}). */
(function () {
  if (window.__bvVideos) return;
  window.__bvVideos = true;

  var hayIO = 'IntersectionObserver' in window;
  var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var bucle = hayIO ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var box = e.target;
      var v = box.querySelector('video');
      if (!v || box.__sonido) return;
      if (e.isIntersecting) { ambiente(box, v); } else if (!v.paused) { v.pause(); }
    });
  }, { threshold: 0.5 }) : null;

  function ambiente(box, v) {
    preparar(box);
    v.muted = true;
    v.loop = true;
    v.setAttribute('muted', '');
    box.classList.add('is-ambient', 'is-muted');
    try {
      var p = v.play();
      if (p && p.catch) p.catch(function () { box.classList.remove('is-ambient'); });
    } catch (err) { box.classList.remove('is-ambient'); }
  }
  var cerca = hayIO ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { preparar(e.target); cerca.unobserve(e.target); } });
  }, { rootMargin: '200px 200px' }) : null;
  var enVista = hayIO ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) return;
      var v = e.target.querySelector('video');
      if (v && !v.paused) v.pause();
    });
  }, { threshold: 0.15 }) : null;

  function fuente(box) {
    return box.getAttribute('data-src-max') || box.getAttribute('data-src-hd') || box.getAttribute('data-src');
  }

  function preparar(box) {
    var v = box.querySelector('video');
    if (!v || v.getAttribute('src')) return;
    v.preload = 'metadata';
    v.src = fuente(box);
  }

  function medir(nombre, box) {
    var datos = {
      video: box.getAttribute('data-video') || '',
      productos: (box.getAttribute('data-productos') || '').split(',').filter(Boolean),
      contexto: box.getAttribute('data-contexto') || '',
      producto_pagina: box.getAttribute('data-pagina-producto') || '',
      pagina: location.pathname
    };
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(nombre, datos);
      }
    } catch (err) {}
  }

  function montar(box) {
    if (box.__bvv) return;
    box.__bvv = true;
    var v = box.querySelector('video');
    var relleno = box.querySelector('.bvv__bar i');
    if (!v) return;
    v.addEventListener('playing', function () {
      box.classList.remove('is-loading');
      if (box.classList.contains('is-ambient')) {
        if (!box.__medidoBucle) { box.__medidoBucle = true; medir('bv_video_bucle', box); }
        return;
      }
      box.classList.add('is-live', 'is-playing');
      if (!box.__medido) { box.__medido = true; medir('bv_video_play', box); }
    });
    v.addEventListener('pause', function () { box.classList.remove('is-playing'); });
    v.addEventListener('ended', function () {
      box.classList.remove('is-playing');
      if (relleno) relleno.style.width = '0';
      medir('bv_video_fin', box);
    });
    v.addEventListener('timeupdate', function () {
      if (relleno && v.duration && isFinite(v.duration)) {
        relleno.style.width = 'calc((100% - 28px) * ' + (v.currentTime / v.duration).toFixed(4) + ')';
      }
    });
    v.addEventListener('volumechange', function () { box.classList.toggle('is-muted', v.muted); });
    v.addEventListener('error', function () { box.classList.remove('is-loading'); });
    if (hayIO) { cerca.observe(box); enVista.observe(box); } else { preparar(box); }
    if (bucle && !quieto && box.hasAttribute('data-bucle')) bucle.observe(box);
  }

  function montarTodo() {
    var lista = document.querySelectorAll('[data-bvv]');
    for (var i = 0; i < lista.length; i++) {
      if (!lista[i].closest('.dialog-zoomed-gallery')) montar(lista[i]);
    }
  }

  function reproducir(box, v, reintento) {
    preparar(box);
    if (!box.classList.contains('is-live')) box.classList.add('is-loading');
    var otros = document.querySelectorAll('[data-bvv] video');
    for (var i = 0; i < otros.length; i++) { if (otros[i] !== v && !otros[i].paused) otros[i].pause(); }
    function fallo(err) {
      if (!reintento && (!err || err.name !== 'NotAllowedError')) {
        setTimeout(function () { reproducir(box, v, true); }, 80);
        return;
      }
      box.classList.remove('is-loading');
    }
    try {
      var p = v.play();
      if (p && p.catch) p.catch(fallo);
    } catch (err) { fallo(err); }
  }

  function tarjeta(e) {
    var t = e.target;
    return t && t.closest ? t.closest('[data-bvv]') : null;
  }

  document.addEventListener('mousedown', function (e) {
    if (!tarjeta(e)) return;
    e.stopPropagation();
    if (e.button === 0) e.preventDefault();
  }, true);
  document.addEventListener('dragstart', function (e) { if (tarjeta(e)) e.preventDefault(); }, true);

  document.addEventListener('click', function (e) {
    var box = tarjeta(e);
    if (!box) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    montar(box);
    var v = box.querySelector('video');
    if (!v) return;
    var t = e.target;
    if (box.classList.contains('is-ambient')) {
      box.__sonido = true;
      box.classList.remove('is-ambient', 'is-muted');
      v.loop = false;
      v.muted = false;
      v.removeAttribute('muted');
      try { v.currentTime = 0; } catch (err) {}
      if (!v.paused) {
        /* ya estaba sonando en silencio: no habrá un nuevo «playing», se pasa a modo con sonido aquí */
        box.classList.add('is-live', 'is-playing');
        if (!box.__medido) { box.__medido = true; medir('bv_video_play', box); }
        var otros = document.querySelectorAll('[data-bvv] video');
        for (var i = 0; i < otros.length; i++) { if (otros[i] !== v && !otros[i].paused) otros[i].pause(); }
      } else {
        reproducir(box, v, false);
      }
      return;
    }
    if (t.closest('.bvv__mute')) { v.muted = !v.muted; return; }
    var barra = t.closest('.bvv__bar');
    if (barra && box.classList.contains('is-live')) {
      var r = barra.getBoundingClientRect();
      var x = Math.min(1, Math.max(0, (e.clientX - r.left - 14) / (r.width - 28)));
      if (v.duration && isFinite(v.duration)) v.currentTime = x * v.duration;
      return;
    }
    if (box.classList.contains('is-loading')) return;
    if (v.paused) reproducir(box, v, false); else v.pause();
  }, true);

  var temporizador;
  function programar() { clearTimeout(temporizador); temporizador = setTimeout(montarTodo, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', montarTodo); else montarTodo();
  document.addEventListener('shopify:section:load', programar);
  if ('MutationObserver' in window) new MutationObserver(programar).observe(document.documentElement, { childList: true, subtree: true });
})();
